export const INGREDIENT_SEARCH_SOURCE = "ingredients-search";

export type IngredientSearchNavigationContext = {
  q: string | null;
  category: string | null;
  source: string | null;
  page: number | null;
};

function buildIngredientSearchParams({
  q,
  category,
  source,
  page,
}: IngredientSearchNavigationContext) {
  const params = new URLSearchParams();

  if (q) {
    params.set("q", q);
  }

  if (category) {
    params.set("category", category);
  }

  if (source) {
    params.set("source", source);
  }

  if (page && page > 1) {
    params.set("page", String(page));
  }

  return params;
}

export function buildIngredientSearchHref(
  context: IngredientSearchNavigationContext,
) {
  const params = buildIngredientSearchParams(context);
  const suffix = params.toString();

  return suffix ? `/ingredients/search?${suffix}` : "/ingredients/search";
}

export function buildIngredientDetailsHref({
  slug,
  ...context
}: IngredientSearchNavigationContext & { slug: string }) {
  const params = buildIngredientSearchParams(context);
  params.set("from", INGREDIENT_SEARCH_SOURCE);

  return `/ingredients/${slug}?${params.toString()}`;
}

export function buildIngredientDetailsBackHref({
  from,
  ...context
}: IngredientSearchNavigationContext & { from: string | null }) {
  if (from !== INGREDIENT_SEARCH_SOURCE) {
    return "/ingredients";
  }

  return buildIngredientSearchHref(context);
}
